'use strict'

export default function ()
{

	function _apply ( element )
	{
		var $container = document.querySelector(element.getAttribute('scroll-container'))

		;($container !== null) 
			? _init(element, $container) 
			: setTimeout(function(){ _apply(element) }, 100)
	}

	function _init ( element, $container )
	{
		var $scroll = $container.querySelector('.content'),
			offset = parseInt(element.getAttribute('scroll-lock'))

		$scroll.addEventListener('scroll', function ( e ) {
			element.style.position = 'absolute'
			element.style.top = ''
			element.style.left = ''

			if ($scroll.scrollTop - element.offsetTop + offset > 0)
			{
				element.style.left = getOffset(element) + 'px'
				element.style.position = 'fixed'
				element.style.top = offset + 'px'
			}
		})
	}

	function getOffset ( element )
	{
		var off = element.offsetLeft,
			parent = element.parentElement

		while (parent !== document.body)
		{
			off += parent.offsetLeft
			parent = parent.parentElement
		}

		return off
	}

	return {
		restrict: 'A',
		scope: {},
		link: function ( scope, elements, attrs )
			{
				angular.forEach(elements, _apply)
			}
	}
}


// WEBPACK FOOTER //
// ./src/app/directives/scroll-lock/scroll-lock.directive.js